import { TFunction } from 'i18next';
import { DateTimeCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';
import { RiskIQAccess } from 'types/graphql-global-types';

export const riskIQAccessTranslationKeys: Record<RiskIQAccess, string> = {
    [RiskIQAccess.NO_ACCESS]: 'riskIQAccess.noAccess',
    [RiskIQAccess.READ_ONLY_ACCESS]: 'riskIQAccess.readOnlyAccess',
    [RiskIQAccess.READ_ONLY_READ_WRITE_COMMENTS_ACCESS]: 'riskIQAccess.readOnlyReadWriteCommentsAccess',
    [RiskIQAccess.READ_WRITE_ACCESS]: 'riskIQAccess.readWriteAccess',
};

export const getTrialOsStudyTeamColumns = (t: TFunction): GridColumnProps[] => [
    {
        id: 'riskIQ',
        field: 'riskIQ',
        title: t('grid.columns.riskIQ'),
        filter: 'text',
        minWidth: 150,
        lovData: Object.values(riskIQAccessTranslationKeys).map((key) => t(key)),
    },
    {
        id: 'lastName',
        field: 'lastName',
        title: t('grid.columns.lastName'),
        filter: 'text',
        minWidth: 150,
    },
    {
        id: 'firstName',
        field: 'firstName',
        title: t('grid.columns.firstName'),
        filter: 'text',
        minWidth: 150,
    },
    {
        id: 'email',
        field: 'email',
        title: t('grid.columns.email'),
        filter: 'text',
        minWidth: 200,
    },
    {
        id: 'createdOn',
        field: 'createdOn',
        title: t('grid.columns.createdOn'),
        filter: 'date',
        minWidth: 130,
        cells: { data: DateTimeCell('DD-MMM-yyyy') },
        cellName: 'DateCell',
    },
    {
        id: 'createdBy',
        field: 'createdBy',
        title: t('grid.columns.createdBy'),
        filter: 'text',
        minWidth: 150,
    },
    {
        id: 'updatedOn',
        field: 'updatedOn',
        title: t('grid.columns.updatedOn'),
        filter: 'date',
        minWidth: 130,
        cells: { data: DateTimeCell('DD-MMM-yyyy') },
        cellName: 'DateCell',
    },
    {
        id: 'updatedBy',
        field: 'updatedBy',
        title: t('grid.columns.updatedBy'),
        filter: 'text',
        minWidth: 150,
    },
];
